import React from "react";
import RecyclingSidebar from "../components/RecyclingSidebar";
import RecyclingDashboard from "../components/RecyclingDashboard";

const RecyclingDashboardPage = () => {
  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <RecyclingSidebar />
      <RecyclingDashboard />
    </div>
  );
};

export default RecyclingDashboardPage;
